import type { DateFunctionsByType, RHSType } from '@pega/cosmos-react-condition-builder';

export const convertRhsTypes = (
  useLiteralRHSType: boolean,
  useFieldRHSType: boolean,
  useRelativeDatesType: boolean,
  useParameterRHSType: boolean,
  dateFunctions?: DateFunctionsByType
) => {
  const setRhsTypes: Set<RHSType> = new Set<RHSType>();
  if (useLiteralRHSType) setRhsTypes.add('LITERAL');
  if (useFieldRHSType) setRhsTypes.add('FIELD');
  if (dateFunctions) setRhsTypes.add('DATE_FUNCTION');
  if (useRelativeDatesType) setRhsTypes.add('RELATIVE_DATE');
  if (useParameterRHSType) setRhsTypes.add('PARAMETER');
  return setRhsTypes;
};
